import sidebarReducer from './sidebar';

export const rootReducer = {
  sidebar: sidebarReducer,
};
